export default __webpack_public_path__ + "static/media/08.b1042fef.png";